import * as T from './loyaltyRewardsTypes';
import type { Reward } from '../../../components/loyalty/data/types';
import type {
  UpdateRewardPayload,
  ListRewardsParams,
} from '../../../services/rewardCatalogApi';

export const fetchRewardsRequest = (params?: ListRewardsParams) => ({
  type: T.FETCH_REWARDS_REQUEST as typeof T.FETCH_REWARDS_REQUEST,
  payload: params,
});
export const fetchRewardsSuccess = (rewards: Reward[]) => ({
  type: T.FETCH_REWARDS_SUCCESS as typeof T.FETCH_REWARDS_SUCCESS,
  payload: { rewards },
});
export const fetchRewardsFailure = (error: string) => ({
  type: T.FETCH_REWARDS_FAILURE as typeof T.FETCH_REWARDS_FAILURE,
  payload: error,
});

export const fetchRewardDetailRequest = (rewardId: string) => ({
  type: T.FETCH_REWARD_DETAIL_REQUEST as typeof T.FETCH_REWARD_DETAIL_REQUEST,
  payload: rewardId,
});
export const fetchRewardDetailSuccess = (reward: Reward) => ({
  type: T.FETCH_REWARD_DETAIL_SUCCESS as typeof T.FETCH_REWARD_DETAIL_SUCCESS,
  payload: reward,
});
export const fetchRewardDetailFailure = (error: string) => ({
  type: T.FETCH_REWARD_DETAIL_FAILURE as typeof T.FETCH_REWARD_DETAIL_FAILURE,
  payload: error,
});

export const updateRewardRequest = (rewardId: string, payload: UpdateRewardPayload) => ({
  type: T.UPDATE_REWARD_REQUEST as typeof T.UPDATE_REWARD_REQUEST,
  payload: { rewardId, data: payload },
});
export const updateRewardSuccess = (rewardId: string, reward: Partial<Reward>) => ({
  type: T.UPDATE_REWARD_SUCCESS as typeof T.UPDATE_REWARD_SUCCESS,
  payload: { rewardId, reward },
});
export const updateRewardFailure = (error: string) => ({
  type: T.UPDATE_REWARD_FAILURE as typeof T.UPDATE_REWARD_FAILURE,
  payload: error,
});

export const clearRewardsError = () => ({
  type: T.CLEAR_REWARDS_ERROR as typeof T.CLEAR_REWARDS_ERROR,
});

export type LoyaltyRewardsAction =
  | ReturnType<typeof fetchRewardsRequest>
  | ReturnType<typeof fetchRewardsSuccess>
  | ReturnType<typeof fetchRewardsFailure>
  | ReturnType<typeof fetchRewardDetailRequest>
  | ReturnType<typeof fetchRewardDetailSuccess>
  | ReturnType<typeof fetchRewardDetailFailure>
  | ReturnType<typeof updateRewardRequest>
  | ReturnType<typeof updateRewardSuccess>
  | ReturnType<typeof updateRewardFailure>
  | ReturnType<typeof clearRewardsError>;
